module.exports = __webpack_public_path__ + "static/media/23.d71b9ea3.png";